var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMultimedia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 600,
    viewBox: "0 0 450 450",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 225 0 C 100.734375 0 0 100.734375 0 225 C 0 349.265625 100.734375 450 225 450 C 349.265625 450 450 349.265625 450 225 C 450 100.734375 349.265625 0 225 0 Z M 225 0 ",
    fill: "#28a745",
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(225,225) scale(1.12) translate(-225,-225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 143 131 L 307 131 C 316.941 131 325 139.059 325 149 L 325 268 L 125 268 L 125 149 C 125 139.059 133.059 131 143 131 Z M 149 155 L 149 244 L 301 244 L 301 155 Z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 104 283 L 346 283 C 350.418 283 354 286.582 354 291 L 354 296 C 354 307.046 345.046 316 334 316 L 116 316 C 104.954 316 96 307.046 96 296 L 96 291 C 96 286.582 99.582 283 104 283 Z",
    fill: "#ffffff",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMultimedia);
export default __webpack_public_path__ + "static/media/icon_multimedia.bb0d009fc5ec59cd49fe707fc5a0ecc5.svg";
export { ForwardRef as ReactComponent };